import { call, put, takeEvery } from "redux-saga/effects";
import { axios } from "lib/axios";
import AppUtils from "../../../util/util";
import { baseUrl } from "../../../util/keys";
import {
  HTTP_TIMEOUT,
  URL_CONNECT_GET_CASE_HANDLING_REPLY_CASE_SATISFACTION,
} from "../../../constants/Urls";

import {
  CONNECT_API_GET_CASE_SATISFACTION_REQUEST,
  CONNECT_API_GET_CASE_SATISFACTION_SUCCESS,
  CONNECT_API_GET_CASE_SATISFACTION_FAILURE,
} from "../../../constants/ActionTypes";
import { REPORT_FILTERS_API_CALLS_COMPLETE } from "../../../constants/actions/reports/actionsReportFilters";

export function* getCaseSatisfaction() {
  yield takeEvery(
    CONNECT_API_GET_CASE_SATISFACTION_REQUEST,
    connectGetCaseSatisfaction
  );
}

const fetchConnectGetCaseSatisfaction = async ({ payload }) =>
  await axios
    .post(
      baseUrl + URL_CONNECT_GET_CASE_HANDLING_REPLY_CASE_SATISFACTION,
      payload,
      AppUtils.getHttpHeaders()
    )
    .then((authUser) => authUser)
    .catch((error) => error);
// worker saga: makes the api call when watcher saga sees the action
export function* connectGetCaseSatisfaction(payload) {
  try {
    const response = yield call(fetchConnectGetCaseSatisfaction, payload);
    const { data, message } = response;
    if (data) {
      yield put({
        type: CONNECT_API_GET_CASE_SATISFACTION_SUCCESS,
        caseSatisfaction: data,
      });
    }
    if (message) {
      yield put({
        type: CONNECT_API_GET_CASE_SATISFACTION_FAILURE,
        error: message,
      });
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put({ type: CONNECT_API_GET_CASE_SATISFACTION_FAILURE, error });
  } finally {
    yield put({ type: REPORT_FILTERS_API_CALLS_COMPLETE });
  }
}
